import { createFileRoute, redirect } from '@tanstack/react-router'

// The README of @uptrack-app/mcp named this address, and MCP directories copied it. It was a 404.
// public/robots.txt allows this path, so crawlers can follow the redirect.
export const Route = createFileRoute('/dashboard_/install')({
  beforeLoad: () => {
    throw redirect({ to: '/guides/mcp', statusCode: 301 })
  },
  component: () => null,
})
